import React from "react";

const UserAuthLayout = (props) => {
  const { children } = props;
  return (
    <>
      <section className="signup-layout">{children}</section>
    </>
  );
};

export default UserAuthLayout;
